<template>
  <div>
    <v-layout wrap>
      <v-layout wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 >
          <v-toolbar color="primary" dark >
            <v-toolbar-title>Báo cáo tổng quan lớp</v-toolbar-title>
            <v-spacer/>
          </v-toolbar>
        </v-flex>
        <v-flex xs12 style="padding: 10px">
          <v-layout wrap>
            <v-flex xs4 style="padding-left: 50px;">
              <i-datepicker
                  value=""
                  label="Từ ngày"
                  clearable
                  @clearText="clearFromDate"
                  @change="onChangeFromDate"
              />
            </v-flex>
            <v-flex xs4 style="padding-left: 50px; padding-right: 50px">
              <i-datepicker
                  value=""
                  label="Đến ngày"
                  clearable
                  @clearText="clearToDate"
                  @change="onChangeToDate"
              />
            </v-flex>
            <v-flex xs4  style="justify-content: center; align-content: center">
              <div class="text-title" >
                <v-btn color="primary" @click="onView">
                  Tìm kiếm
                </v-btn>
                <v-btn color="primary" @click="onExport">
                  Xuất báo cáo
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/schoolClass/generalClassReport"
            create-url="/schoolClass/save"
            delete-url="/schoolClass/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            :custom-edit-item="false"
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="false"
            :accept-edit="false"
            :acceptCreate2=false
            :accept-create=false
            :acceptExport="0"
            :displayToolbar=false
            @showReport="showReport"
            @viewItem=""
        >
        </c-search-form>
        <template #slot-percent="{ item }">
          <div style="display: flex; align-items: center;">
            <v-progress-linear
                :value="item.percent"
                height="10"
                color="blue"
                style="flex: 1; margin-right: 8px"
            />
            <span>{{ item.percent }}%</span>
          </div>
        </template>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants, requestConstants} from "@/constants";
import axios from "axios";
import SchoolCreateForm from "@/views/admin/school_class/SchoolClassCreate";
import {message} from "@/shared/message";

export default {
  name: "school-class",
  components: {SchoolCreateForm, CSearchForm},
  data: () => {
    return {

      formName: "Báo cáo lớp học",
      formCreateName: "Thêm mới lớp",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },

      // fromDate: (new Date()).setDate(new Date().getDate() - 7),
      // toDate: new Date(),

      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'className',
          text: 'Tên lớp',
          search: true,
          sortable:false,
          width: "17%",
          headerStyle: "text-align:center",
        },
        {
          value: 'classAccount',
          text: 'Tên tài khoản',
          search: true,
          sortable:false,
          width: "17%",
          headerStyle: "text-align:center",
        },
        {
          value: "levelStartId",
          text: "Trình độ",
          search: true,
          headerStyle: "text-align:center",
          type: "select",
          name: "levelStartId",
          items: [],
          itemText: "categoryName",
          itemValue: "categoryId",
          width: "8%",
        },
        {
          value: 'percent',
          text: 'Tiến độ',
          search: true,
          sortable:false,
          width: "40%",
          headerStyle: "text-align:center",
          type: 'progressbar',
        },
      ],
    };
  },

  created() {
    // this.hiddenFields.fromDate = this.fromDate;
    // this.hiddenFields.toDate = this.toDate;
    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_AGE&pageSize=-1&page=-1", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "ageId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
        );
    axios.post(
        process.env.VUE_APP_API_URL + "/category/onSearch?categoryTypeCode=SCHOOL_LEVEL_START&pageSize=-1&page=-1", {status: 1}
    )
        .then(
            (data) => {
              let itemFields = this.fields.filter(function (e) {
                return e.name == "levelStartId";
              });
              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data.items;
              }
            }
        );

  },

  methods: {
    onView(){
      if(this.hiddenFields.fromDate == null){
        message.error("Chưa nhập Từ ngày");
        return;
      }
      if(this.hiddenFields.toDate == null){
        message.error("Chưa nhập đến ngày");
        return;
      }
      this.timeReload = Math.random();
    },
    onExport(){
      if(this.hiddenFields.fromDate == null){
        message.error("Chưa nhập Từ ngày");
        return;
      }
      if(this.hiddenFields.toDate == null){
        message.error("Chưa nhập đến ngày");
        return;
      }
      axios({
        url: process.env.VUE_APP_API_URL + "/schoolClass/exportGeneralClassReport",
        method: "POST",
        data: {"fromDate": this.hiddenFields.fromDate, "toDate": this.hiddenFields.toDate},
        responseType: "blob", // important
      }).then(response => {
        if (response) {
          const url = window.URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Tongquan_lop" + ".xlsx");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        }
      });
    },
    showReport(item) {
      window.open(item.reportLink, "_blank");
    },
    clearFromDate() {
      this.hiddenFields.fromDate = null;
      this.fromDate = null;
    },
    clearToDate() {
      this.toDate = null;
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.fromDate = date;
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.toDate = date;
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học';
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học';
      }
      this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },


    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
  },

  destroyed() {
  },
};
</script>
